import { Col, Row } from "react-bootstrap";
import Menu, { MenuDefinition } from "../components/Menu";
import React, { useEffect, useState } from "react";
import useUXStore from "../api/ux/store";
import MenuNavigation from "./MenuNavigation";
import { useAuth } from "../api/auth/store";
import { useNavigate } from "react-router";
import { CLIENT_ID } from "../constants";
import ProfileCardPreview from "./ProfileCardPreview";
import Loading from "./Loading";

type MenuProps = {
    pages: MenuDefinition[]
    branding?: JSX.Element
    defaultPage: string
}

const MenuPage: React.FC<MenuProps> = ({ branding, pages, defaultPage }) => {
    const [init, setInit] = useState(false)
    const { loadSession, featuresActive, restoreLastCompany, setRestoringCompany, restoringCompany } = useAuth(state => state)
    const [page, setPage] = useState<MenuDefinition | null>(null)
    const { replacePage, setHome, currentPage } = useUXStore(state => state)
    const { sessionDetails } = useAuth(state => state)
    const navigate = useNavigate()
    //console.log("DDD", sessionDetails)

    useEffect(() => {
        setHome({ Label: pages[0].label, Element: pages[0].element, Id: pages[0].id })

        let foundPage: MenuDefinition | null = null;
        for (const element of pages) {
            if (element.id === defaultPage) {
                foundPage = element;
                break;
            }
            if (element.subs) {
                for (const sub of element.subs) {
                    if (sub.id === defaultPage) {
                        foundPage = sub as any;
                        break;
                    }
                }
            }
            if (foundPage) break;
        }

        if (foundPage) {
            setPage(foundPage);
            // Replace page in UX store to trigger update in MenuNavigation
            replacePage(foundPage.label, foundPage.element, foundPage.id);
        }

        if (!init) {
            loadSession().then(code => {
                switch (code) {
                    case "200":
                        // make the last selected company active again before rendering pages
                        restoreLastCompany()
                        break;
                    case "":
                        // still loading
                        setRestoringCompany(false)
                        break;
                    default:
                        setRestoringCompany(false)
                        navigate("/sso?client=" + CLIENT_ID)
                        break;
                }
            }).catch(() => {
                // never leave the shell stuck behind the restore gate
                setRestoringCompany(false)
            })
            setInit(true)
        }
    }, [defaultPage, pages])


    // callback when menu was selected
    const onMenuSelected = (_selected: string) => {
        //console.log(_selected)
        if (_selected !== currentPage?.Id) {
            // find page
            for (let index = 0; index < pages.length; index++) {
                const page = pages[index];
                if (page.id === _selected) {
                    replacePage(page.label, page.element, page.id)
                    navigate(page.path!)
                    break;
                }
                if (!page.subs) continue;

                for (let index = 0; index < page.subs!.length; index++) {
                    const subpage = page.subs![index];
                    if (subpage.id === _selected) {
                        replacePage(subpage.label, subpage.element, subpage.id)
                        navigate(subpage.path!)
                        break
                    }
                }
            }
        }
    }
    const isMenuActive = (id: string) => {
        return featuresActive[id] !== false
    }
    return (
        <Row className="flex-nowrap">
            <Col className="sidebar-col">
                <div className="sticky-menu">
                    {branding}
                    <ProfileCardPreview user={sessionDetails!} onClick={() => {
                        const firstPage = pages[0]
                        replacePage(firstPage.label, firstPage.element, firstPage.id)
                        navigate(firstPage.path!)
                    }} />
                    {sessionDetails && !restoringCompany && <Menu selected={currentPage ? currentPage!.Id! : ""}
                        getActive={isMenuActive} onSelected={onMenuSelected} defs={pages} />}
                </div>
            </Col>
            <Col className="content-col">
                {restoringCompany && <Loading center />}
                {page && !restoringCompany && <MenuNavigation initialPage={{
                    Label: page?.label!,
                    Element: page?.element
                }} />}
            </Col>
        </Row>

    )
}

export default MenuPage;